import { call, put, takeLatest } from 'redux-saga/effects';

import { psmAuditDigital, notification } from '../../actionTypes';
import dataProvider from '../../store/dataProvider';
import { getNotificationErrorMessage, mergeFollowUpSavePayload } from './helpers';

function* followUpUpdate({ payload: { auditFollowUpId, auditId, data, companyId } }) {
  try {
    const { data: response } = yield call(dataProvider.updateOnly, `audit/follow-up/${auditFollowUpId}`, data);
    const followUp = mergeFollowUpSavePayload((response && response.data) || response || null, {
      ...data,
      auditId,
    });
    yield put({
      type: psmAuditDigital.followUpUpdate.end,
      payload: followUp,
    });
    yield put({ type: notification.add, payload: { success: 'Follow-up updated successfully' } });
    if (companyId) {
      yield put({ type: psmAuditDigital.list.start, payload: { companyId } });
    }
    if (data.status === 'Completed' && companyId) {
      yield put({ type: psmAuditDigital.pendingCompanyRedirectSet, payload: { companyId } });
    }
  } catch (e) {
    yield put({ type: psmAuditDigital.followUpUpdate.error });
    yield put({
      type: notification.add,
      payload: { error: getNotificationErrorMessage(e, 'Failed to update follow-up') },
    });
  }
}

export default function* followUpUpdateSaga() {
  yield takeLatest(psmAuditDigital.followUpUpdate.start, followUpUpdate);
}
